import React from 'react';
import { withStyles } from '../../../../../shared/utils/withStyles';
import styles from './balls-loader.styl';
export default withStyles(styles)(function () { return (React.createElement("div", { className: styles.container },
    React.createElement("div", { className: styles.ballOne }),
    React.createElement("div", { className: styles.ballTwo }),
    React.createElement("div", { className: styles.ballThree }))); });
